import React, { useEffect, useState } from "react";
import { IS_LOCAL_ENV } from "../../App";
import InDevelopment from "../InDevelopment";
import CommonTitle from "../../components/CommonTitle";
import { IoIosAdd } from "react-icons/io";
import Notification from "../../components/ui-elements/Notification";
import LoadingPage from "../../components/LoadingPage";
import BlogCard from "../../components/blogs/BlogCard";
import blogIcon from "../../assets/icons/blog.webp";
import { getBlogsByPage } from "../../services/blogs";
import ModalStructure from "../../components/ModalStructure";
import BlogForm from "../../components/blogs/BlogForm";
import Pagination from "../../components/Pagination";

const Blogs = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  useEffect(() => {
    setLoading(true);
    const fetchBlogs = async () => {
      try {
        const { docs, totalPages } = await getBlogsByPage(currentPage);
        IS_LOCAL_ENV && console.log("docs", docs);
        setBlogs(docs);
        setTotalPages(totalPages);
        setLoading(false);
      } catch (err) {
        Notification({
          title: "Error",
          text: "Error al cargar los blogs",
          type: "Error",
        });
        setLoading(false);
        IS_LOCAL_ENV && console.error(err);
      }
    };
    fetchBlogs();
  }, [currentPage]);

  const loadToParent = (newObj, prevId) => {
    let temp = [...blogs];
    if (!prevId) {
      temp.push(newObj);
      setBlogs(temp);
    } else {
      const prevIndex = temp.findIndex((obj) => obj.id == prevId);
      if (prevIndex == -1) return;
      temp[prevIndex] = newObj;
      setBlogs(temp);
    }
  };

  const removeFromParent = (id) => {
    let temp = [...blogs];
    const prevIndex = temp.findIndex((obj) => obj.id == id);
    if (prevIndex == -1) return;
    temp.splice(prevIndex, 1);
    setBlogs(temp);
  };

  //if (!IS_LOCAL_ENV) return <InDevelopment />;
  //else
  return (
    <div className="w-full h-full bg-light-green flex flex-col pb-4">
      <CommonTitle
        title="Blog"
        text="Crea y modifica cada artículo del blog del e-commerce."
        img={blogIcon}
      >
        <button
          className={` w-fit bg-accent-green text-base m-1 rounded-full py-4 px-6 text-white hover:bg-dark-green transition-all duration-100 font-bold font-poppins `}
          onClick={() => setShowModal(true)}
        >
          <div className="flex flex-row items-center">
            <span className="text-nowrap">Crear Artículo</span>
            <IoIosAdd />
          </div>
        </button>
      </CommonTitle>
      {loading ? (
        <LoadingPage />
      ) : (
        <div className="flex flex-col items-center w-full justify-center bg-light-green h-fit">
          <div className="flex flex-wrap max-w-[1920px] w-full justify-center md:p-6 p-2 h-full gap-4">
            {blogs.map((blog, i) => {
              return (
                <BlogCard
                  info={blog}
                  key={`${i + blog.updatedAt}`}
                  loadToParent={loadToParent}
                  removeFromParent={removeFromParent}
                />
              );
            })}
          </div>
          <Pagination
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            totalPages={totalPages}
          />
        </div>
      )}
      {/**Modals */}
      {showModal && (
        <ModalStructure
          handleCloseModal={() => setShowModal(false)}
          customMaxW={"max-w-[550px]"}
        >
          <BlogForm
            handleClose={() => setShowModal(false)}
            loadToParent={loadToParent}
          />
        </ModalStructure>
      )}
    </div>
  );
};

export default Blogs;
